"use client";
import { AppContext } from "app/context/app_context";
import GlobalConfig, { BuildEnv } from "react_next/config/config";

export interface RootScreenProps {
  children: React.ReactNode;
  env: BuildEnv;
  isDebug: boolean;
}

export default function RootScreen({
  children,
  env,
  isDebug,
}: RootScreenProps) {
  if (env) {
    GlobalConfig.env = env;
  }
  if (isDebug) {
    GlobalConfig.isDebug = isDebug;
  }
  function promise() {
    return Promise.resolve();
  }
  GlobalConfig.isDebug = isDebug;
  GlobalConfig.env = env;

  return <AppContext.Provider value={{}}>{children}</AppContext.Provider>;
}
